import React, { Component } from "react";
import { Menu, Segment, Grid } from "semantic-ui-react";
import Loading from "./Loading/index";
//Components
import Topo from "../../components/Topo";
import Footer from "../../components/Footer";

import { producaov2 as api } from "../../services/apis";
import { verify_mobile } from "../../utils/Utils";

class MeusCupons extends Component {
  state = {
    cupons: [],
    activeItem: 1,
    loading: 1,
    showCopy: false,
  };

  handleItemClick = (item) => this.setState({ activeItem: item });

  loadapi = () => {
    api
      .get("cupons/pessoa")
      .then((res) => {
        let data_cupons = res.data;
        data_cupons.sort(function (a, b) {
          return new Date(b.data_sys) - new Date(a.data_sys);
        });
        this.setState({ cupons: data_cupons, loading: 0 });
      })
      .catch((err) => {
        this.setState({ loading: 0 });
      });
  };

  convertDate = (date) => {
    if (date) {
      return new Date(date).toLocaleDateString("pt-BR");
    }
    return "";
  };
  componentDidMount = async () => {
    this.loadapi();
  };

  redirectCupom = async (validade, idInput) => {
    if (new Date(validade) > new Date()) {
      let textArea = document.querySelector(`#${idInput}`);
      textArea.select();
      document.execCommand("copy");
      this.setState({ showCopy: true });

      setTimeout(() => {
        this.setState({ showCopy: false });
      }, 4500);
      return;
    }
    return "";
  };

  loadConteudo = () => {
    return (
      <div id="sobreDiv" class="ui grid container sobreDiv">
        <div class={!verify_mobile() ? "ui grid container" : "cuponsMobile"}>
          <div class="twelve wide column">
            <p style={{ fontWeight: "bold", fontSize: "15px" }}>
              FUNCIONAMENTO DOS CUPONS
            </p>
            <p>
              <i class="right triangle icon"></i> Os Cupons Voitto são válidos
              para a compra de cursos digitais. Após recebê-los, selecione seu
              curso em{" "}
              <a target="_blank" href="/cursos">
                Treinamentos Digitais
              </a>
              , faça a inscrição e aplique o cupom.
            </p>
            <p>
              <i class="right triangle icon"></i> Se o pedido for cancelado ou
              não confirmado, seu cupom volta a estar disponível para o uso em
              outra compra, até o vencimento de sua validade.
            </p>
            <p>
              <i class="right triangle icon"></i> Os cupons não se aplicam a
              materiais impressos.
            </p>

            <p style={{ fontWeight: "bold", fontSize: "15px" }}>
              VALIDADE DOS CUPONS
            </p>
            <p>
              <i class="right triangle icon"></i>A validade do cupom está
              discriminada na área Meus Cupons. Após expirado, não será possível
              utilizá-lo.
            </p>

            <p style={{ fontWeight: "bold", fontSize: "15px" }}>
              POSSO UTILIZAR MAIS DE UMA FORMA DE DESCONTO?
            </p>
            <p style={{ marginBottom: verify_mobile() ? "3%" : null }}>
              <i class="right triangle icon"></i>Não, você só pode usar uma
              forma de desconto por compra. Os cupons não são acumulativos com
              outros descontos.
            </p>
          </div>
          <div
            class="four wide column centered promoVingente"
            style={{ marginTop: "0.7%" }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                borderBottom: "1px solid black",
              }}
            >
              Promoção aniversariantes <i class="bullhorn icon"></i>
            </p>
            <div class="descPromo">
              No seu aniversário te presenteamos com um cupom de R$ 150 para
              você crescer ainda mais.
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { activeItem } = this.state;
    return (
      <>
        <div>
          <style>
            {`
            @font-face { font-family:"Righeteous";src:url("/assets/fonts/Diversas/Righteous.ttf") format(ttf)}

            #myVouchers{
              display:none;
            }
            
            .sobreDiv a {
              color: #4183c4 !important;
            }

            #myAchievements{
                display:none;
            }
            #contentMeusCupons{
                margin: 2%;
            }
            .cupons{
              width:33%;
            }
            .cupomItem {
              background-color:rgba(234, 234, 234,0.3);
              padding: 10px;
              border: 3px dashed #ccc; 
              margin: 5.8%;
            }
            
            bigFont{
              font-size:25px;
              font-weight: bold;
              margin-top:10px;
              top: 5px;
              position: relative;
            }
            .button{
              bottom: 8px;
                position: relative;
            }
            fRight{
              float:right;
              font-family: 'Righeteous'!important;
            }
            .dataRec{
              margin-top:10px;
            }
            
            .ppBorder{
              border-bottom:1px solid #808080;
              padding:10x;
            }
            .motivo{
              margin-left:7px;
            
            }
            .promoVingente{
              padding: 15px 15px 0;
              background-color: white;
              box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);
              -moz-box-shadow: 0 1px 2px rgba(34,25,25,0.4);
              -webkit-box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4);
              height: 40%;
            }
            .titlePromo{
              float:left;
              color:orange;
              font-size:14px;
              margin:15px 15px 15px 0px;
              font-weight:bold;
              clear: left;
            }
            .promoVingente h5{
              border-bottom:1px solid #808080;
              padding:10x;
              text-align:center;
            }
            .descPromo{
              clear:left;
              margin-bottom:10px;
            }
            .tiny{
              text-align:left;
              font-size:10px;
            }
            table{
              text-align:center;
            }

            .ui.top.attached.tabular.menu a{
              color:#000 !important;
            }

            /*Desktop*/
            @media (min-width: 1000px) 
            {
              .cupomItem {
                margin-top:2%
              }
            }
            
            /* Mobile */
            @media (max-width: 800px) 
            {
              .cupomItem {
                top:-15px;
                position:relative;
                margin-bottom:-2px;
                width:106%;
                margin-left:-5px;
              }
              .promoVingente{
                display: none!important;
              }
              .cuponsMobile{
                margin-left:-5%;
                margin-top:7%;
                text-align:left;
              }

            }        

            `}
          </style>

          <Topo />
          <div class="menu-spacer" style={{ minHeight: "80px" }}></div>
          {this.state.showCopy && (
            <div
              class="ui positive message"
              style={{ maxWidth: "60%", margin: "10px auto" }}
            >
              <i class="close icon"></i>
              <div class="header">
                O cupom foi copiado para a sua área de transferência
              </div>
              <p>
                Agora é só utilizá-lo para{" "}
                <a href={"/"} target={"_blank"}>
                  {" "}
                  <b> realizar suas compras </b>{" "}
                </a>
              </p>
            </div>
          )}
          <div class="ui container">
            <div
              class="ui top header"
              style={{ paddingLeft: "10px", width: "100%", marginTop: "2%" }}
            >
              <h1>
                MEUS CUPONS <i class="tag icon"></i>
              </h1>
            </div>

            <Menu attached="top" tabular>
              <Menu.Item
                name="Meus cupons"
                active={activeItem === 1}
                onClick={() => this.handleItemClick(1)}
              />

              <Menu.Item
                name="Sobre"
                active={activeItem === 2}
                onClick={() => this.handleItemClick(2)}
              />
            </Menu>
            {activeItem === 2 && (
              <Segment attached="bottom">
                {this.loadConteudo(activeItem)}
              </Segment>
            )}
            {activeItem === 1 &&
              (this.state.cupons.length ? (
                <>
                  <Segment attached="bottom">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Grid
                        columns={3}
                        stackable
                        style={{
                          marginTop: "1%",
                          width: "90%",
                          marginLeft: "0",
                        }}
                      >
                        {this.state.cupons.map((res, key) => (
                          <Grid.Column>
                            <div class="cupomItem">
                              Código do cupom:
                              <br />
                              <bigFont
                                style={{ marginTop: "5px" }}
                                class="cupomCod"
                              >
                                <input
                                  type={"text"}
                                  value={res.codigo}
                                  id={`InvisibleInput${key}`}
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "20px",
                                    padding: "5px 7.5px",
                                    border: "none",
                                    background: "rgba(0,0,0,0)",
                                    cursor: "default",
                                    letterSpacing: "1px",
                                  }}
                                />
                              </bigFont>
                              <br />
                              <p class="dataRec">
                                Recebido em {this.convertDate(res.data_sys)}{" "}
                              </p>
                              <p
                                style={{
                                  height: verify_mobile() ? "64px" : "40px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                class="ppBorder"
                              >
                                Motivo: <p class="motivo">{res.descricao}</p>
                              </p>
                              <p
                                class="ppBorder"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                Validade:
                                <div>{this.convertDate(res.validade)}</div>
                              </p>
                              <p>
                                {res.ispercent
                                  ? "Porcentagem:"
                                  : "Valor do crédito"}

                                <br />
                                <bigFont>
                                  {res.ispercent
                                    ? `${res.desconto}%`
                                    : `R$ ${res.desconto}`}
                                </bigFont>
                                <fRight>
                                  {res.validade && (
                                    <button
                                      onClick={() =>
                                        this.redirectCupom(
                                          res.validade,
                                          `InvisibleInput${key}`
                                        )
                                      }
                                      disabled={
                                        new Date(res.validade) < new Date()
                                      }
                                      class="ui  mini black button"
                                      style={{ marginTop: 8 }}
                                    >
                                      {new Date(res.validade) > new Date()
                                        ? "Usar cupom"
                                        : "Expirado"}
                                    </button>
                                  )}
                                </fRight>
                              </p>
                            </div>
                          </Grid.Column>
                        ))}
                      </Grid>
                    </div>
                  </Segment>
                </>
              ) : this.state.loading ? (
                <Segment attached="bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "1%",
                      minHeight: "60vh",
                    }}
                  >
                    <Loading />
                  </div>
                </Segment>
              ) : (
                <Segment attached="bottom">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "1%",
                      minHeight: "60vh",
                    }}
                  >
                    <h1> Ops, você ainda não possui nenhum cupom :( </h1>
                  </div>
                </Segment>
              ))}
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default MeusCupons;
